<template>
  <div>
    <b-card
      title="系統設定管理"
      class="mb-0"
    >
      <b-alert
        v-model="successAlert"
        variant="success"
        dismissible
        class="mb-2"
      >
        {{ successMessage }}
      </b-alert>

      <b-alert
        v-model="errorAlert"
        variant="danger"
        dismissible
        class="mb-2"
      >
        {{ errorMessage }}
      </b-alert>

      <b-form @submit.prevent="updateSettings">
        <b-row>
          <b-col md="6">
            <b-form-group
              label="開戶所需 X Coin"
              label-for="coin_to_open_account"
            >
              <b-form-input
                id="coin_to_open_account"
                v-model="formData.coin_to_open_account"
                type="number"
                min="0"
                :state="validationState('coin_to_open_account')"
                required
              />
              <b-form-invalid-feedback>
                請輸入有效的正整數
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group
              label="每次搜尋所需 X Coin"
              label-for="coin_per_search"
            >
              <b-form-input
                id="coin_per_search"
                v-model="formData.coin_per_search"
                type="number"
                min="0"
                :state="validationState('coin_per_search')"
                required
              />
              <b-form-invalid-feedback>
                請輸入有效的正整數
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group
              label="半年外個人財務狀況額外所需 X Coin"
              label-for="coin_extra_records"
            >
              <b-form-input
                id="coin_extra_records"
                v-model="formData.coin_extra_records"
                type="number"
                min="0"
                :state="validationState('coin_extra_records')"
                required
              />
              <b-form-invalid-feedback>
                請輸入有效的正整數
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group
              label="15日以外查詢紀錄額外所需 X Coin"
              label-for="coin_extra_search_records"
            >
              <b-form-input
                id="coin_extra_search_records"
                v-model="formData.coin_extra_search_records"
                type="number"
                min="0"
                :state="validationState('coin_extra_search_records')"
                required
              />
              <b-form-invalid-feedback>
                請輸入有效的正整數
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>

        <div class="d-flex justify-content-end mt-2">
          <b-button
            variant="primary"
            type="submit"
            :disabled="isSubmitting"
          >
            <b-spinner v-if="isSubmitting" small />
            <span>儲存設定</span>
          </b-button>
        </div>
      </b-form>
    </b-card>

    <!-- 設定變更記錄 -->
    <b-card
      title="設定變更記錄"
      class="mt-3"
    >
      <b-row class="mb-2">
        <b-col md="4">
          <b-form-group label="篩選設定項目">
            <b-form-select
              v-model="filter.key_set"
              :options="filterOptions"
              @change="fetchLogs"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-table
        striped
        hover
        responsive
        :items="logs"
        :fields="fields"
        :busy="isLoading"
      >
        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle" />
            <strong>載入中...</strong>
          </div>
        </template>

        <template #cell(key_set)="data">
          <span>{{ getSettingName(data.item.key_set) }}</span>
        </template>

        <template #cell(created_at)="data">
          <span>{{ formatLocalDateTime(data.item.created_at) }}</span>
        </template>
      </b-table>

      <b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        align="center"
        class="mt-3"
        @change="fetchLogs"
      />
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BButton,
  BAlert,
  BTable,
  BSpinner,
  BFormSelect,
  BPagination,
  BFormInvalidFeedback,
  BForm,
} from 'bootstrap-vue'
import axiosIns from '@/libs/axios'
import { formatDate } from '@core/utils/filter'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BAlert,
    BTable,
    BSpinner,
    BFormSelect,
    BPagination,
    BFormInvalidFeedback,
    BForm,
  },
  data() {
    return {
      formData: {
        coin_to_open_account: '',
        coin_per_search: '',
        coin_extra_records: '',
        coin_extra_search_records: '',
      },
      originalData: {},
      isSubmitting: false,
      successAlert: false,
      errorAlert: false,
      successMessage: '',
      errorMessage: '',

      // 設定變更記錄
      logs: [],
      fields: [
        { key: 'user.name', label: '操作人員' },
        { key: 'key_set', label: '設定項目' },
        { key: 'old_value', label: '原始值' },
        { key: 'new_value', label: '變更值' },
        { key: 'created_at', label: '變更時間' },
      ],
      isLoading: false,
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      filter: {
        key_set: null,
      },
      filterOptions: [
        { value: null, text: '全部' },
        { value: 'coin_to_open_account', text: '開戶所需 X Coin' },
        { value: 'coin_per_search', text: '每次搜尋所需 X Coin' },
        { value: 'coin_extra_records', text: '半年外個人財務狀況額外所需 X Coin' },
        { value: 'coin_extra_search_records', text: '15日以外查詢紀錄額外所需 X Coin' },
      ],
    }
  },
  created() {
    this.fetchSettings()
    this.fetchLogs()
  },
  methods: {
    formatDate,

    // 格式化為本地時間
    formatLocalDateTime(dateTimeStr) {
      if (!dateTimeStr) return '';

      // 直接使用簡單的字串替換方法
      // 將 2025-05-23T06:06:21.000000Z 轉換為 2025-05-23 06:06:21
      if (dateTimeStr.includes('T')) {
        // 移除 T 並替換為空格
        let formattedDate = dateTimeStr.replace('T', ' ');

        // 移除毫秒和時區部分
        formattedDate = formattedDate.replace(/\.\d+Z$/, '');

        return formattedDate;
      }

      return dateTimeStr;
    },

    // 獲取設定名稱
    getSettingName(key) {
      // 查找對應的中文名稱
      const option = this.filterOptions.find(opt => opt.value === key)

      // 如果找到對應的選項，返回中文名稱，否則返回原始鍵值
      return option ? option.text : key
    },

    // 驗證表單
    validationState(field) {
      const value = this.formData[field]
      if (value === '') return null

      // 檢查是否為非負整數
      return /^\d+$/.test(value) && parseInt(value, 10) >= 0
    },

    // 獲取系統設定
    async fetchSettings() {
      try {
        const response = await axiosIns.get('/settings')

        // 將設定值填入表單
        response.data.settings.forEach(setting => {
          if (this.formData.hasOwnProperty(setting.key_set)) {
            this.formData[setting.key_set] = setting.value
          }
        })

        // 保存原始數據用於比較
        this.originalData = { ...this.formData }
      } catch (error) {
        console.error('獲取系統設定失敗', error)
        this.showError('獲取系統設定失敗')
      }
    },

    // 更新系統設定
    async updateSettings() {
      // 驗證所有欄位
      for (const field in this.formData) {
        if (this.validationState(field) === false) {
          this.showError('請檢查表單中的錯誤')
          return
        }
      }

      this.isSubmitting = true

      try {
        await axiosIns.put('/settings', this.formData)

        // 更新成功
        this.showSuccess('系統設定已成功更新')

        // 更新原始數據
        this.originalData = { ...this.formData }

        // 重新獲取變更記錄
        this.fetchLogs()
      } catch (error) {
        console.error('更新系統設定失敗', error)
        this.showError(error.response?.data?.message || '更新系統設定失敗')
      } finally {
        this.isSubmitting = false
      }
    },

    // 獲取設定變更記錄
    async fetchLogs() {
      this.isLoading = true

      try {
        const params = {
          perPage: this.perPage,
          page: this.currentPage,
        }

        if (this.filter.key_set) {
          params.key_set = this.filter.key_set
        }

        const response = await axiosIns.get('/settings/logs', { params })
        console.log('API 返回的設定變更記錄:', response.data);

        if (response.data.logs && response.data.logs.data) {
          this.logs = response.data.logs.data
          this.totalRows = response.data.logs.total

          // 調試日誌
          console.log('設定變更記錄數據:', this.logs);
          if (this.logs.length > 0) {
            console.log('第一條記錄:', this.logs[0]);
            console.log('操作人員:', this.logs[0].user);
            console.log('設定項目:', this.logs[0].key_set);
            console.log('變更時間:', this.logs[0].created_at);
          }
        } else {
          console.warn('API 返回的數據格式不符合預期');
          this.logs = []
          this.totalRows = 0
        }
      } catch (error) {
        console.error('獲取設定變更記錄失敗', error)
        this.showError('獲取設定變更記錄失敗')
      } finally {
        this.isLoading = false
      }
    },

    // 顯示成功訊息
    showSuccess(message) {
      this.successMessage = message
      this.successAlert = true

      // 5秒後自動關閉
      setTimeout(() => {
        this.successAlert = false
      }, 5000)
    },

    // 顯示錯誤訊息
    showError(message) {
      this.errorMessage = message
      this.errorAlert = true

      // 5秒後自動關閉
      setTimeout(() => {
        this.errorAlert = false
      }, 5000)
    },
  },
}
</script>
